export const services = [
  {
    number: "01.",
    title: "Professional Services",
    description: "Expert services delivered with precision and reliability.",
  },
  {
    number: "02.",
    title: "Premium Machinery Solutions",
    description: "High-quality machinery and expert support for all your project needs.",
  },
  {
    number: "03.",
    title: "Machinery Sale",
    description: "Top-quality machinery for sale, offering durable solutions to fit your operational needs.",
  },
  {
    number: "04.",
    title: "Industry Projects",
    description: "Efficient machinery for all industry projects.",
  },
  {
    number: "05.",
    title: "Project Management",
    description: "Efficient management for seamless project execution.",
  },
  {
    number: "06.",
    title: "Project Expert Hiring",
    description: "Experienced professionals to expertly handle all your project requirements.",
  },
];